"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preventEvents = function (e) { return e && e.preventDefault && e.preventDefault(); };
//# sourceMappingURL=preventEvents.js.map